module.exports = __webpack_public_path__ + "static/media/cardtype.203a6f66.svg";